export default __webpack_public_path__ + "static/media/curved11.9a8331f4.jpg";